import React from 'react';
import cx from 'classnames';
import Styles from './SeasonalConditions.module.scss';

interface Props {
  activeIndex: number;
  conditions: {
    display: string;
    type: string;
  }[];
  setActiveIndex: Function;
}

const getItemClassnames = (isActive: boolean) =>
  cx({
    [Styles.seasonalConditionsListItem]: true,
    [Styles[`seasonalConditionsListItem--active`]]: isActive,
  });

const getConditionClassnames = (type: string, start: boolean, end: boolean) =>
  cx({
    [Styles.seasonalConditionsListItemCondition]: true,
    [`sl-conditions-color--poor-background`]: type === 'low',
    [`sl-conditions-color--good-background`]: type === 'high',
    [`sl-conditions-color--fair-background`]: type === 'shoulder',
    [Styles[`seasonalConditionsListItemCondition--notype`]]: !type,
    [Styles['seasonalConditionsListItemCondition--start']]: start,
    [Styles['seasonalConditionsListItemCondition--end']]: end,
  });

const handleKeyDown = (event: any, index: number, setActiveIndex: Function) => {
  if (event.keyCode === 13) setActiveIndex(index);
};

const SeasonalConditions: React.FC<Props> = ({ activeIndex, conditions, setActiveIndex }) => (
  <div className={Styles.seasonalConditions}>
    <div className={Styles.seasonalConditionsList}>
      {}
      {conditions.map(({ display, type }: { display: string; type: string }, index: number) => (
        <button
          className={getItemClassnames(activeIndex === index)}
          key={display}
          onClick={() => setActiveIndex(index)}
          onKeyDown={(event) => handleKeyDown(event, index, setActiveIndex)}
          type="button"
        >
          {display}
          <div
            className={getConditionClassnames(
              type,
              type !== conditions[index - 1]?.type,
              type !== conditions[index + 1]?.type,
            )}
          />
        </button>
      ))}
    </div>
  </div>
);

export default SeasonalConditions;
